<template>
    <div class="user-content" :class="[sizeString ? 'user-content-' + sizeString : '', {'m-auto': center, 'text-center': centerText}]">
        <slot/>
        <template v-if="contentParts && contentParts.length">
            <template v-for="(content, contentIndex) in contentParts" :key="contentIndex">
                <lazy-image-modal v-if="content.type === 'image'" :src="buildImageSrc(content)" class="my-16"/>
                <div v-else v-html="content.content"/>
            </template>
        </template>
    </div>
</template>

<script>
import Sizeable from "../../mixins/Sizeable";

export default {
    name: "UserContent",
    mixins: [Sizeable],

    props: {
        text: {
            type: String,
            default: null
        },

        center: {
            type: Boolean,
            default: false
        },

        centerText: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        contentParts() {
            if (!this.text || !this.text.length) {
                return [];
            }

            return [{type: 'text', content: this.text}];

            // Split at image tags
            // TODO: This currently causes render issues due to the image-wrapper class
            const splitContent = this.text.split(/(?:<[a-z]+>)?(<img(?:[\w\W]+?)>)(?:<\/[a-z]+>)?/gm);
            const parts = [];
            splitContent.forEach(content => {
                if (content.startsWith('<img')) {
                    const imagePathMatch = content.match(/data-spoferan-path="(.*?)"/);

                    // We do not want to display dynamic images within a modal
                    if (imagePathMatch && !imagePathMatch[1].endsWith('gif') && !imagePathMatch[1].endsWith('svg')) {
                        let ratio = null;
                        const ratioMatch = content.match(/data-spoferan-ratio="(.*?)"/);
                        if (ratioMatch) {
                            ratio = ratioMatch[1];
                        }
                        parts.push({type: 'image', src: imagePathMatch[1], ratio: ratio})
                        return;
                    }
                }

                parts.push({type: 'text', content: content})

            })

            return parts;
        }
    },

    methods: {
        buildImageSrc(image) {
            const ratio = image.ratio ? image.ratio : 3 / 2;
            const isHorizontal = ratio >= (3 / 2);

            return [{
                path: image.src,
                size: {
                    ratio: ratio,
                    width: isHorizontal ? '100vw' : null,
                    height: isHorizontal ? null : 552,
                    sm: {width: isHorizontal ? 640 : null, height: isHorizontal ? null : 552},
                    lg: {width: isHorizontal ? 900 : null, height: isHorizontal ? null : 552}
                },
                preview: {
                    size: {
                        ratio: ratio,
                        width: isHorizontal ? '100vw' : null,
                        height: isHorizontal ? null : 368,
                        md: {width: isHorizontal ? 736 : null, height: isHorizontal ? null : 368}
                    }
                }
            }]
        }
    }
}
</script>

<style>
@charset "UTF-8";
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.app .user-content {
  text-align: left;
  max-width: 950px;
  color: #465050;
  font-size: 15px;
}
.app .user-content h2, .app .user-content h3, .app .user-content h4, .app .user-content h5, .app .user-content h6 {
  font-weight: 600;
  margin-bottom: 1rem;
  line-height: 1.3;
  font-family: nunito-sans, Arial, Helvetica, sans-serif;
}
.app .user-content h2 {
  font-size: 20px;
}
.app .user-content h3 {
  font-size: 18px;
}
.app .user-content h4 {
  font-size: 16px;
}
.app .user-content p {
  margin-bottom: 1rem;
  line-height: 1.5;
  font-size: 15px;
}
.app .user-content p:last-child {
  margin-bottom: 0;
}
.app .user-content ul {
  list-style: disc inside;
}
.app .user-content ol {
  list-style: decimal inside;
}
.app .user-content ul, .app .user-content ol {
  margin-bottom: 16px;
  margin-top: 0;
  padding-left: 40px;
}
.app .user-content ul li, .app .user-content ol li {
  padding: 4px 0;
  line-height: 1.3;
  list-style-position: outside;
}
.app .user-content ul li > p, .app .user-content ol li > p {
  display: inline;
  line-height: 1.3;
  font-size: 14.6px;
}
.app .user-content ul li > p > img:only-child, .app .user-content ol li > p > img:only-child {
  display: block;
}
.app .user-content ul li ul, .app .user-content ol li ul {
  margin-top: 4px;
  margin-bottom: 0;
  padding-left: 24px;
}
@media (max-width: 767px) {
  .app .user-content ul, .app .user-content ol {
    padding-left: 24px;
  }
}
.app .user-content hr {
  height: 1px;
  border: 0;
  width: 100%;
  text-align: center;
  margin: 16px auto;
  background-color: #d8d8d8;
}
.app .user-content blockquote {
  position: relative;
  padding-left: 1em;
  border-left: 3px solid #e6ecf5;
}
.app .user-content blockquote:before, .app .user-content blockquote:after {
  content: "“";
}
.app .user-content blockquote:after {
  content: "”";
}
.app .user-content .ql-indent-1 {
  margin-left: 25px;
}
.app .user-content .ql-indent-2 {
  margin-left: 50px;
}
.app .user-content .ql-indent-3 {
  margin-left: 75px;
}
.app .user-content .ql-indent-4 {
  margin-left: 100px;
}
.app .user-content .ql-indent-5 {
  margin-left: 125px;
}
.app .user-content .ql-indent-6 {
  margin-left: 150px;
}
.app .user-content .ql-indent-7 {
  margin-left: 175px;
}
.app .user-content .ql-indent-8 {
  margin-left: 200px;
}
.app .user-content .ql-indent-9 {
  margin-left: 225px;
}
.app .user-content .ql-indent-10 {
  margin-left: 250px;
}
.app .user-content table {
  border-spacing: 0;
  border-color: #d8d8d8;
  border-collapse: collapse;
  table-layout: fixed;
  overflow: hidden;
  width: 100%;
}
.app .user-content table td, .app .user-content table th {
  padding: 8px;
  border: 2px solid #d8d8d8;
  color: #465050;
  vertical-align: top;
  box-sizing: border-box;
  text-align: left;
}
.app .user-content table td p, .app .user-content table th p {
  margin-bottom: 0;
}
.app .user-content img {
  border-radius: 5px;
  max-height: 400px;
  max-width: 100%;
}
.app .user-content div > img {
  margin: 16px 0;
}
.app .user-content a:not(.btn):hover {
  text-decoration: underline;
}
.app .user-content iframe {
  max-width: 100%;
}
.app .user-content-xs {
  font-size: 12px;
}
.app .user-content-xs h2 {
  font-size: 15px;
}
.app .user-content-xs h3 {
  font-size: 13px;
}
.app .user-content-xs h4 {
  font-size: 12px;
}
.app .user-content-xs p {
  font-size: 12px;
}
.app .user-content-xs ul, .app .user-content-xs ol {
  padding-left: 24px;
}
.app .user-content-xs ul li > p, .app .user-content-xs ol li > p {
  font-size: 11.6px;
}
.app .user-content-sm {
  font-size: 14px;
}
.app .user-content-sm h2 {
  font-size: 16px;
}
.app .user-content-sm h3 {
  font-size: 15px;
}
.app .user-content-sm h4 {
  font-size: 14px;
}
.app .user-content-sm p {
  font-size: 14px;
}
.app .user-content-sm ul, .app .user-content-sm ol {
  padding-left: 32px;
}
.app .user-content-sm ul li > p, .app .user-content-sm ol li > p {
  font-size: 13.6px;
}
.app .user-content-sm ul li ul, .app .user-content-sm ol li ul {
  padding-left: 16px;
}
.app .user-content-lg {
  font-size: 17px;
}
.app .user-content-lg p {
  line-height: 1.7;
  font-size: 17px;
}
.app .user-content-lg ul li > p, .app .user-content-lg ol li > p {
  font-size: 17px;
  line-height: 1.4;
}
.app .user-content-lg h2 {
  font-size: 22px;
}
.app .user-content-lg h3 {
  font-size: 20px;
}
.app .user-content-lg h4 {
  font-size: 18px;
}
@media (max-width: 639px) {
  .app .user-content-lg {
    font-size: 16px;
  }
  .app .user-content-lg p {
    font-size: 16px;
  }
  .app .user-content-lg ul li > p, .app .user-content-lg ol li > p {
    font-size: 16px;
  }
  .app .user-content-lg h2 {
    font-size: 20px;
  }
  .app .user-content-lg h3 {
    font-size: 18px;
  }
  .app .user-content-lg h4 {
    font-size: 17px;
  }
}
</style>